import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { actionToJson } from "./actionToJson.js";
export var ActionModel = /*#__PURE__*/function () {
  function ActionModel() {
    _classCallCheck(this, ActionModel);
    this._actionModel = {};
  }
  return _createClass(ActionModel, [{
    key: "toJson",
    value: function toJson() {
      return actionToJson.apply(this);
    }
  }]);
}();